import type { Ctx } from '@milkdown/kit/ctx';
import { renderToStaticMarkup } from 'react-dom/server';

import { showEmbedTooltip, type EmbedConfig } from './tooltip';

/** Type for slash menu item configuration (matches Crepe's SlashMenuItem) */
export interface SlashMenuItemConfig {
  label: string;
  icon: string;
  onRun: (ctx: Ctx) => void;
}

/**
 * Convert embed definition to tooltip config
 */
function createEmbedConfig(provider: any): EmbedConfig {
  return {
    label: `Embed ${provider.label}`,
    icon: provider.icon,
    placeholder: provider.placeholder,
    isValidUrl: provider.matcher,
    invalidUrlMessage: provider.invalidUrlMessage,
  };
}

/**
 * Creates a slash menu item factory for a specific embed provider.
 * Called lazily at menu build time to avoid module initialization order issues.
 */
export const createSlashMenuItemForProvider = (provider: any) => {
  const config = createEmbedConfig(provider);

  return (): SlashMenuItemConfig => ({
    label: provider.label,
    icon: renderToStaticMarkup(provider.icon as React.ReactElement),
    onRun: (ctx: Ctx) => {
      showEmbedTooltip(ctx, config);
    },
  });
};
